import React from "react"
import styled from "styled-components"
import { debounce } from "../../util/debounce"
import { appStrings } from "../../common/strings/app_strings"
import { colors } from "../../common/colors/app_colors"

const { defaultDescription, defaultDescSubtext } = appStrings.connectedApps
const { silver } = colors

export class DefaultDescriptionField extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            description: "",
        }
    }

    componentDidMount() {
        this.sendDescriptionChange = debounce(this.sendDescriptionChange, 1000)
        this.setState({ description: this.props.defaultDescription })
    }

    handleTextChange = e => {
        this.setState({ description: e.target.value })
        this.sendDescriptionChange(e.target.value.trim())
    }
    sendDescriptionChange = description => {
        this.props.handleSetDescription(description, this.props.configId)
    }

    render() {
        return (
            <DescriptionFieldWrapper>
                <h5>{defaultDescription}</h5>
                <span className="subtext">{defaultDescSubtext}</span>
                <input
                    value={this.state.description}
                    className="form-control text-field"
                    onChange={this.handleTextChange}
                />
            </DescriptionFieldWrapper>
        )
    }
}

const DescriptionFieldWrapper = styled.div`
    padding: 5px 0;
    .subtext {
        font-weight: 400;
        font-size: small;
        margin-top: 10px;
    }
    .text-field {
        width: 90%;
        overflow: hidden;
        resize: none;
        border-radius: 4px;
        border: 1px solid ${silver};
        outline: none;
    }
    .text-field:focus {
        border: 1px solid ${silver};
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/default_description_field.jsx